export type ReviewSeverity = "error" | "warning" | "info";

export interface ArchitectReviewComment {
  severity: ReviewSeverity;
  ruleId: string;
  path?: string;
  message: string;
}

export interface ArchitectReviewPayload {
  reviewedAt?: string;
  reviewedBy?: string;
  standardsVersion?: string;
  summary?: string;
  score?: number;
  comments: ArchitectReviewComment[];
}

const REVIEW_BLOCK_RE = /```architect-review\s*([\s\S]*?)```/i;
const JSON_BLOCK_RE = /```json\s*([\s\S]*?)```/i;

export function parseArchitectReviewJson(raw: string | null | undefined): ArchitectReviewPayload | null {
  if (!raw?.trim()) return null;
  try {
    const parsed = JSON.parse(raw) as ArchitectReviewPayload;
    if (!Array.isArray(parsed.comments)) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function extractArchitectReviewFromMessage(content: string): ArchitectReviewPayload | null {
  const match = content.match(REVIEW_BLOCK_RE);
  if (!match?.[1]) return null;
  return parseArchitectReviewJson(match[1].trim());
}

export function extractOpenApiJsonFromMessage(content: string): string | null {
  const match = content.match(JSON_BLOCK_RE);
  if (!match?.[1]) return null;
  const text = match[1].trim();
  try {
    JSON.parse(text);
    return text;
  } catch {
    return null;
  }
}

export function serializeArchitectReview(review: ArchitectReviewPayload): string {
  return JSON.stringify(review);
}
